import { create } from 'zustand';

export const STEPS = [
  'enter-email',
  'sign-up/fill-name',
  'sign-up/how-did-you-hear-about-us',
  'sign-up/what-do-you-want-to-sell',
  'confirm-email',
];

interface LoginState {
  email: string;

  setEmail: (email: string) => void;
}

export const useLoginStore = create<LoginState>((set) => ({
  email: '',
  setEmail: (email) => set({ email }),
}));
